import TextButton from 'LuxKit/Button/TextButton'
import SolidPlusIcon from 'LuxKit/Icons/solid/SolidPlusIcon'
import TextLink from 'LuxKit/TextLink'
import Caption from 'LuxKit/Typography/Caption'
import { MAX_ROOM_LIMIT } from 'constants/offer'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { formatSaleUnitCount } from 'hooks/useSaleUnitPlural'
import { getSupportContact } from 'selectors/supportContactSelector'

interface Props {
  className?: string
  contactNumber?: App.GeoContact
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void
  roomsCount: number
  saleUnit?: string
  maxRooms?: number
  noServiceContact?: boolean
}

function AddRoomButton(props: Props) {
  const {
    className,
    contactNumber,
    onClick,
    roomsCount,
    saleUnit,
    maxRooms = MAX_ROOM_LIMIT,
    noServiceContact,
  } = props
  const intl = useIntl()
  const unit = saleUnit || 'room'
  const pluralizeSaleUnit = formatSaleUnitCount(intl, saleUnit || 'room', maxRooms)

  return (
    <div className={className} data-testid="add-room-button">
      {roomsCount < maxRooms && <TextButton
        kind="tertiary"
        size="medium"
        startIcon={<SolidPlusIcon />}
        horizontalOutdent="start"
        onClick={onClick}
      >
        {intl.formatMessage(
          {
            id: 'HY50p_JSMzMzpIIFWFwU',
            defaultMessage: 'Add another {unit}',
            description: 'Button text to add another room to occupancy selection',
          },
          { unit },
        )}
      </TextButton>}
      {(roomsCount >= maxRooms && !noServiceContact && contactNumber) &&
        <Caption variant="medium" weight="bold">
          <FormattedMessage
            id="GW6yib32zBgDsbT3HQl4"
            defaultMessage="For bookings of more than {pluralizeSaleUnit} please contact our customer service team on <link>{contactNumber}</link>."
            description="Caption directing users to contact support for bookings exceeding the room limit"
            values={{
              pluralizeSaleUnit,
              contactNumber: contactNumber.humanReadable,
              link: (chunks) => <TextLink href={`tel:${contactNumber.number}`} rel="nofollow">{chunks}</TextLink>,
            }}
          />
        </Caption>}
    </div>
  )
}

function mapStateToProps(state: App.State) {
  return {
    contactNumber: getSupportContact(state).defaultContact,
  }
}

export default connect(mapStateToProps)(AddRoomButton)
